/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

// KARAAT custom: metal swatch image swap (migrated from Broadcast 5.8.2 custom.js, 2026-07-02;
// updated 2026-07-10 for Broadcast 8.1.1, mobile/touch, and event delegation).
// 8.1.1 hides the variant image layers with `visibility:hidden` (not just opacity:0) and reveals
// them via the native `.is-visible` class. The old 5.8.2 code toggled inline opacity, which no
// longer works on 8.1.1 (visibility stays hidden), so we toggle `.is-visible` instead.
// EVENT DELEGATION: listeners live on `document`, not on each swatch. The engagement collection
// (<collection-component>) re-renders its product grid via AJAX on filter / sort / paginate, so
// per-element listeners bound at page load would go dead for any product rendered after load.
// Delegation covers current AND future swatches. Acts only on swatches carrying data-variant-id
// (the KARAAT metal swatches); Broadcast's own colour swatches are left to its native JS.
(function () {
  function swatchFrom(target) {
    return target && target.closest ? target.closest('.swatch__button[data-variant-id]') : null;
  }
  function cardOf(swatch) {
    return swatch.closest('.product-item') || document;
  }
  function clearVariantImages(card) {
    card.querySelectorAll('.product-item__bg__inner.is-visible').forEach(function (layer) {
      layer.classList.remove('is-visible');
    });
  }
  function showVariantImage(swatch) {
    var card = cardOf(swatch);
    clearVariantImages(card);
    var target = card.querySelector('.product-item__bg__inner[data-variant-id="' + swatch.dataset.variantId + '"]');
    if (target) {
      target.classList.add('is-visible');
    }
  }

  // Desktop (pointer with hover): mouseover/mouseout bubble, so delegation catches them.
  document.addEventListener('mouseover', function (event) {
    var swatch = swatchFrom(event.target);
    if (swatch) {
      showVariantImage(swatch);
    }
  });
  document.addEventListener('mouseout', function (event) {
    var swatch = swatchFrom(event.target);
    // Keep the image steady while the pointer moves between the swatch and its own children;
    // only revert when the pointer actually leaves the swatch.
    if (swatch && !(event.relatedTarget && swatch.contains(event.relatedTarget))) {
      clearVariantImages(cardOf(swatch));
    }
  });

  // Mobile / touch (no hover): a tap can't hover, so swap the image on tap instead of jumping
  // straight to the variant link. preventDefault stops the swatch's inner <a> from navigating;
  // the shopper opens the product by tapping the card image. Desktop is unaffected because the
  // `(hover: none)` media query only matches touch devices.
  document.addEventListener('click', function (event) {
    if (!window.matchMedia('(hover: none)').matches) {
      return;
    }
    var swatch = swatchFrom(event.target);
    if (!swatch) {
      return;
    }
    event.preventDefault();
    showVariantImage(swatch);
  });
})();

// KARAAT custom: non-EU cart taxes & duties notice (2026-07-09).
// DDP (taxes & duties prepaid) is offered ONLY for Norway (NO) and Switzerland (CH).
// All other non-EU countries are directed to contact customer support.
// geolocation.js resolves the visitor's country from /browsing_context_suggestions.json and
// sets data-user-country on <html>; cart.liquid shows #non-eu-notification for non-EU visitors.
(function () {
  var PAID = {
    fi: 'Verot ja tullit maksettu',
    sv: 'Skatter och tullar betalda',
    en: 'Taxes & duties paid'
  };
  // TODO: add fi/sv once confirmed; until then these fall back to en.
  var OTHER = {
    en: 'Taxes & duties may apply for your country — please contact customer support before ordering.'
  };
  var DDP_COUNTRIES = { NO: true, CH: true };

  function applyNonEuNotice() {
    var el = document.getElementById('non-eu-notification');
    if (!el) { return false; }
    var country = (document.documentElement.getAttribute('data-user-country') || '').toUpperCase();
    if (!country) { return false; } // wait until geolocation.js resolves the country
    var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var set = DDP_COUNTRIES[country] ? PAID : OTHER;
    el.textContent = set[lang] || set.en;
    return true;
  }

  if (!applyNonEuNotice()) {
    var obs = new MutationObserver(function () {
      if (applyNonEuNotice()) { obs.disconnect(); }
    });
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['data-user-country'] });
    setTimeout(function () { obs.disconnect(); }, 10000);
  }
})();

// KARAAT custom: shared delivery-date helper (2026-07-13).
// SINGLE SOURCE OF TRUTH for "ship by" dates: today + production_time days, formatted exactly like
// the product page always has (toLocaleDateString with weekday/month/day). Used by BOTH
// snippets/kaleido_shipping_information.liquid (PDP) and the cart per-line estimates below, so the
// cart and the product page can never disagree. Locale comes from <html lang>, which the theme sets
// to request.locale.iso_code — the same value the PDP snippet used to inline.
window.KaraatKdo = window.KaraatKdo || {};

// Editable weekday names per language, used in the ship-by date ("Lähetetään
// [weekday] [date] mennessä"). Order: Sunday first, then Monday ... Saturday.
// Edit the words below freely — whatever you type here is shown verbatim.
// Languages not listed keep the browser's automatic weekday.
window.KaraatKdo.weekdayNames = {
  fi: ['sunnuntaihin', 'maanantaihin', 'tiistaihin', 'keskiviikkoon', 'torstaihin', 'perjantaihin', 'lauantaihin']
  // sv: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag']
};

window.KaraatKdo.shipDateString = function (days) {
  try {
    var n = Number(days);
    if (!n || n < 0) { return null; }
    var d = new Date();
    d.setDate(d.getDate() + n);
    var locale = document.documentElement.lang || 'en';
    var lang = locale.split('-')[0].toLowerCase();
    var names = (window.KaraatKdo.weekdayNames || {})[lang];
    if (names && names[d.getDay()]) {
      return names[d.getDay()] + ' ' + d.toLocaleDateString(locale, { month: 'long', day: 'numeric' });
    }
    return d.toLocaleDateString(locale, { weekday: 'long', month: 'long', day: 'numeric' });
  } catch (e) { return null; }
};

// KARAAT custom: cart per-line delivery estimates (2026-07-13).
// snippets/cart-line-items.liquid renders each made-to-order line as
//   <p class="cart__kdo-delivery" data-kdo-days="N">…ships by [date]</p>
// hidden via CSS until the date is filled (so "[date]" never flashes). This fills [date] using the
// shared helper above and marks the line data-kdo-filled (CSS reveals it). In-stock lines are fully
// static Liquid and need no JS. Broadcast re-renders the cart drawer/page HTML on every cart change,
// so fresh unfilled lines keep appearing — a debounced document-wide MutationObserver re-runs the
// filler (same pattern as the diamond-quality ⓘ injection). Fails silently.
(function () {
  function fillCartDates() {
    // Per-line estimates AND the mixed-cart notice (whose [date] is the latest ship-by
    // date across all lines, computed in Liquid as max production_time).
    var lines = document.querySelectorAll('.cart__kdo-delivery[data-kdo-days]:not([data-kdo-filled]), .cart__kdo-mixed-notice[data-kdo-days]:not([data-kdo-filled])');
    for (var i = 0; i < lines.length; i++) {
      var el = lines[i];
      try {
        var date = window.KaraatKdo.shipDateString(el.getAttribute('data-kdo-days'));
        var tpl = el.textContent || '';
        if (!date || /translation missing/i.test(tpl)) { continue; } // stays hidden
        el.textContent = tpl.replace('[date]', date);
        el.setAttribute('data-kdo-filled', '1');
      } catch (e) { /* leave hidden */ }
    }
  }
  var scheduled = false;
  function schedule() {
    if (scheduled) { return; }
    scheduled = true;
    setTimeout(function () { scheduled = false; fillCartDates(); }, 16);
  }
  function start() {
    fillCartDates();
    try {
      new MutationObserver(schedule).observe(document.body || document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
})();

// KARAAT custom: optional engraving (2026-07-16).
// The €45 engraving is charged as a REAL hidden product (handle: engraving) paired with the
// ring — never as a VO Product Options price surcharge (VO's surcharge failed to reconcile
// at checkout, which is why this exists).
//
// PDP side: the block (snippets/product-engraving.liquid) sets window.KaraatEngraving; this
// script wires the toggle/char-count and keeps two hidden inputs inside the PRODUCT FORM
// (properties[Engraving] + properties[_engraving_group]), so whatever submits that form —
// VO owns add-to-cart on engagement products — carries the engraving on the ring line itself.
//
// Cart side (runs on every page): a RECONCILER enforces the pairing invariants after every
// cart mutation (VO's add, drawer +/-, removals — detected via observe-only fetch/XHR taps):
//   1. ring line with _engraving_group in state 'pending'  → add one Engraving line (same group)
//   2. Engraving line whose group has no ring left          → remove it (nobody pays €45 for nothing)
//   3. ring whose Engraving line was removed by the customer → strip the ring's engraving
//      properties (keep the ring!) so fulfilment never engraves unpaid text
//   4. quantities: Engraving line follows its ring line
// Group state ('pending' → 'added') lives in sessionStorage, so a customer deleting the €45
// line doesn't get it silently re-added. All failure modes degrade to "no engraving charged".
(function () {
  var CFG = null; // filled lazily; the snippet's inline script may run after us
  var STATE_KEY = 'karaat_engraving_state';

  function cfg() { return window.KaraatEngraving || CFG; }
  function states() {
    try { return JSON.parse(sessionStorage.getItem(STATE_KEY) || '{}'); } catch (e) { return {}; }
  }
  function setState(group, val) {
    try {
      var s = states(); s[group] = val;
      sessionStorage.setItem(STATE_KEY, JSON.stringify(s));
    } catch (e) {}
  }

  /* ---------------- PDP UI ---------------- */
  function initUI() {
    var toggle = document.querySelector('[data-engraving-toggle]');
    if (!toggle || toggle.hasAttribute('data-engraving-wired')) { return; }
    toggle.setAttribute('data-engraving-wired', '1');
    var editor = document.querySelector('[data-engraving-editor]');
    var input = document.querySelector('[data-engraving-input]');
    var count = document.querySelector('[data-engraving-count]');
    var max = (cfg() && cfg().maxLen) || 25;

    // Hidden inputs live INSIDE the product form so any submitter serializes them.
    var form = null;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) { if (forms[i].querySelector('[name="add"], [type="submit"]')) { form = forms[i]; break; } }
    if (!form && forms.length) { form = forms[0]; }
    var propText = null, propGroup = null;
    if (form) {
      propText = document.createElement('input');
      propText.type = 'hidden'; propText.name = 'properties[Engraving]'; propText.disabled = true;
      propGroup = document.createElement('input');
      propGroup.type = 'hidden'; propGroup.name = 'properties[_engraving_group]'; propGroup.disabled = true;
      form.appendChild(propText); form.appendChild(propGroup);
    }
    var group = 'eg-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

    function sync() {
      var on = toggle.checked;
      var text = (input && input.value || '').slice(0, max).trim();
      if (editor) { editor.hidden = !on; }
      if (count && input) { count.textContent = (input.value || '').length + '/' + max; }
      var active = on && text.length > 0;
      if (propText) { propText.disabled = !active; propText.value = text; }
      if (propGroup) { propGroup.disabled = !active; propGroup.value = group; }
      if (active) { setState(group, 'pending'); }
      try { window.KaraatEngraving.currentGroup = active ? group : null; window.KaraatEngraving.currentText = text; } catch (e) {}
    }
    toggle.addEventListener('change', sync);
    if (input) { input.addEventListener('input', sync); }
    sync();
  }

  /* ---------------- cart reconciler ---------------- */
  var busy = false, rerun = false;
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  }
  function strippedProps(props) {
    var out = {};
    for (var k in props) {
      if (k === 'Engraving' || k === '_engraving_group') { continue; }
      out[k] = props[k];
    }
    return out;
  }
  function reconcile() {
    if (busy) { rerun = true; return; }
    busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var rings = {}, engravings = {}, orphanEngravings = [];
      cart.items.forEach(function (it) {
        var g = it.properties && it.properties._engraving_group;
        if (it.handle === 'engraving') {
          if (g && !engravings[g]) { engravings[g] = it; }
          else { orphanEngravings.push(it); } // duplicate group or no group at all
        } else if (g) {
          rings[g] = it;
        }
      });
      var chain = Promise.resolve();
      // engraving lines with no ring → remove (rule 2) + malformed ones
      Object.keys(engravings).forEach(function (g) {
        if (!rings[g]) { chain = chain.then(function () { return post('/cart/change.js', { id: engravings[g].key, quantity: 0 }); }); }
      });
      orphanEngravings.forEach(function (it) {
        chain = chain.then(function () { return post('/cart/change.js', { id: it.key, quantity: 0 }); });
      });
      Object.keys(rings).forEach(function (g) {
        var ring = rings[g];
        var eng = engravings[g];
        if (!eng) {
          var st = states()[g];
          var c = cfg();
          if (st === 'pending' && c && c.variantId) {
            // rule 1: complete the pair
            chain = chain.then(function () {
              return post('/cart/add.js', {
                items: [{ id: c.variantId, quantity: ring.quantity, properties: { Engraving: ring.properties.Engraving || '', _engraving_group: g } }]
              }).then(function (r) { if (r.ok) { setState(g, 'added'); } });
            });
          } else {
            // rule 3: customer removed the €45 line → un-engrave the ring, keep it.
            // Shopify quirk: `properties: {}` on cart/change is IGNORED (you can't clear
            // all properties via change), so a ring with no other properties must be
            // removed and re-added clean. Rings with other props (e.g. VO ring size)
            // take the normal replace path.
            chain = chain.then(function () {
              var props = strippedProps(ring.properties);
              if (Object.keys(props).length > 0) {
                return post('/cart/change.js', { id: ring.key, quantity: ring.quantity, properties: props });
              }
              return post('/cart/change.js', { id: ring.key, quantity: 0 }).then(function () {
                return post('/cart/add.js', { items: [{ id: ring.variant_id, quantity: ring.quantity }] });
              });
            });
          }
        } else if (eng.quantity !== ring.quantity) {
          // rule 4: quantity follows the ring
          chain = chain.then(function () { return post('/cart/change.js', { id: eng.key, quantity: ring.quantity }); });
        }
      });
      return chain;
    }).catch(function () {}).then(function () {
      busy = false;
      if (rerun) { rerun = false; reconcile(); }
    });
  }
  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 450);
  }

  // Observe-only taps on cart mutations (VO uses its own requests; we never rewrite them).
  if (!window.__karaatEngravingTapped) {
    window.__karaatEngravingTapped = true;
    try {
      var origFetch = window.fetch;
      window.fetch = function (input) {
        var p = origFetch.apply(this, arguments);
        try {
          var url = (typeof input === 'string') ? input : ((input && input.url) || '');
          if (/\/cart\/(add|change|update|clear)/.test(url)) { p.then(schedule, function () {}); }
        } catch (e) {}
        return p;
      };
    } catch (e) {}
    try {
      var origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, url) {
        try { this.__karaatCartCall = /\/cart\/(add|change|update|clear)/.test(String(url)); } catch (e) {}
        return origOpen.apply(this, arguments);
      };
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        if (this.__karaatCartCall) { this.addEventListener('loadend', schedule); }
        return origSend.apply(this, arguments);
      };
    } catch (e) {}
  }

  function start() {
    initUI();
    schedule(); // reconcile once on load (covers cross-page/cross-session cleanups)
    try { new MutationObserver(function () { initUI(); }).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
})();

// KARAAT custom: customer-story gallery scroll-progress bar (2026-07-15).
// The 2+ stories layout in snippets/product-customer-story.liquid is a snap-scrolling
// row with a thin progress bar underneath ([data-story-progress]); this keeps the bar
// in sync with the track's horizontal scroll. Binds once per track (guarded), also on
// resize. Fails silently; without JS the bar just stays empty.
(function () {
  // DELEGATION, not per-element binding: the product section's DOM can be cloned or
  // replaced after load (e.g. by the tabs component), which would silently drop
  // element-bound listeners. Scroll events don't bubble, but they ARE catchable in
  // the capture phase on document — so this works for any current or future track.
  function updateTrack(track) {
    try {
      var bar = track.parentElement ? track.parentElement.querySelector('[data-story-progress]') : null;
      if (!bar) { return; }
      var rail = bar.parentElement; // .product-story__progress (hidden by default in CSS)
      var max = track.scrollWidth - track.clientWidth;
      // No overflow (e.g. two cards fitting side by side on desktop) → nothing to
      // scroll, so no progress bar at all. Mobile widths overflow and show it.
      if (max <= 1) {
        if (rail) { rail.style.display = 'none'; }
        return;
      }
      if (rail) { rail.style.display = 'block'; }
      var pct = (track.scrollLeft / max) * 100;
      // keep a starting stub sized like the visible portion, so the bar reads as
      // a progress indicator rather than an empty hairline
      var minStub = (track.clientWidth / track.scrollWidth) * 100;
      bar.style.width = Math.max(pct, minStub) + '%';
    } catch (e) { /* fail silently */ }
  }
  function updateAll() {
    var tracks = document.querySelectorAll('[data-story-track]');
    for (var i = 0; i < tracks.length; i++) { updateTrack(tracks[i]); }
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.nodeType === 1 && t.hasAttribute && t.hasAttribute('data-story-track')) { updateTrack(t); }
  }, true);
  window.addEventListener('resize', updateAll);
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', updateAll); }
  else { updateAll(); }
  // paint the initial stub on late-rendered/cloned tracks
  var storyScheduled = false;
  try {
    new MutationObserver(function () {
      if (storyScheduled) { return; }
      storyScheduled = true;
      setTimeout(function () { storyScheduled = false; updateAll(); }, 50);
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();

// KARAAT custom: Diamond quality info ⓘ trigger (2026-07-13).
// The theme's native variant picker is hidden; the "Diamond quality" selector is drawn by the VO
// Product Options app inside div.best-custom-product-options. We inject an ⓘ next to that option's
// label; clicking it opens the theme-rendered drawer (snippets/product-diamond-quality.liquid) by
// clicking the drawer's hidden [data-dq-open] button — so the theme's own popup behaviour (scroll
// lock, a11y, ESC) is reused. VO rebuilds its DOM on every option change, so we re-inject via a
// MutationObserver and guard against duplicates. LOCALE-SAFE: the option name is translated in
// FI/SV, so we never match on "Diamond quality" — we find the group by the language-independent
// grade strings in its values (G-H / D-F / VVS). Fails silently: VO markup is third-party and may
// change; nothing here may block or break the page if the expected structure isn't found.
(function () {
  var VO_SELECTOR = 'div.best-custom-product-options';
  var GRADE_RE = /VVS|D-F|G-H/i;

  function drawerTrigger() {
    // Only present when the diamond_quality block rendered — i.e. this product has the option.
    return document.querySelector('[data-dq-open]');
  }

  function infoSvg() {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"'
      + ' fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"'
      + ' stroke-linejoin="round" aria-hidden="true" focusable="false">'
      + '<circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg>';
  }

  // The Diamond quality group is the smallest element containing BOTH the Good (G-H) and the
  // Excellent (VVS) grade tokens — that uniquely isolates it from the metal/size/ring-size options.
  function findQualityGroup(voBlock) {
    // Seed = the deepest element whose text contains VVS. Works whether VO renders a value as a
    // leaf <span> or as a <label> wrapping a radio input (the VVS text is then a text node of a
    // non-leaf element), so we don't require the seed to be childless — only that none of its
    // element children also contain VVS.
    var all = voBlock.querySelectorAll('*');
    var seed = null;
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (!/VVS/i.test(el.textContent || '')) { continue; }
      var childHasVVS = false;
      for (var c = 0; c < el.children.length; c++) {
        if (/VVS/i.test(el.children[c].textContent || '')) { childHasVVS = true; break; }
      }
      if (!childHasVVS) { seed = el; break; }
    }
    if (!seed) { return null; }
    // Climb until the ancestor also includes the Good (G-H) tier — that wraps the whole option.
    var node = seed;
    while (node && node !== voBlock) {
      var t = node.textContent || '';
      if (/G-H/i.test(t) && /VVS/i.test(t)) { return node; }
      node = node.parentNode;
    }
    return null;
  }

  // Find the option-name label row (e.g. "Diamond quality") to sit the ⓘ inline with. `valuesEl`
  // (from findQualityGroup) is the *values* container — the name row is a sibling/ancestor of it, so
  // we search OUTSIDE that subtree, walking up the option field. We take the first element that has
  // its own visible text and wraps no form control (that's the title row, which precedes the values).
  function ownText(el) {
    var s = '';
    for (var k = 0; k < el.childNodes.length; k++) { if (el.childNodes[k].nodeType === 3) { s += el.childNodes[k].textContent; } }
    return s.trim();
  }
  function findLabel(valuesEl, voBlock) {
    var field = valuesEl.parentNode;
    for (var up = 0; up < 4 && field && field !== voBlock; up++) {
      var all = field.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        if (el === valuesEl || valuesEl.contains(el) || el.contains(valuesEl)) { continue; } // outside the values subtree
        if (el.querySelector('input, select, textarea, button')) { continue; }               // not a control
        if (ownText(el)) { return el; }
      }
      field = field.parentNode;
    }
    return valuesEl; // last resort — inline at the end of the values row
  }

  // Currently selected quality value (for the GA4 event), read from VO's DOM.
  function selectedQuality(group) {
    try {
      var checked = group.querySelector('input:checked');
      if (checked) {
        if (GRADE_RE.test(checked.value || '')) { return checked.value; }
        var lbl = (checked.id && group.querySelector('label[for="' + checked.id + '"]')) ||
                  (checked.closest ? checked.closest('label') : null);
        if (lbl && GRADE_RE.test(lbl.textContent || '')) { return lbl.textContent.trim(); }
      }
      var sel = group.querySelector('[aria-checked="true"], .selected, .is-selected, .active');
      if (sel && GRADE_RE.test(sel.textContent || '')) { return sel.textContent.trim(); }
    } catch (e) {}
    return null;
  }

  function inject(voBlock) {
    try {
      if (!voBlock) { return; }
      if (voBlock.querySelector('.dq-info-trigger')) { return; }  // already injected this render
      if (!drawerTrigger()) { return; }                          // no drawer on this page → skip
      var group = findQualityGroup(voBlock);
      if (!group) { return; }
      var nameEl = findLabel(group, voBlock);
      // Climb to the option's first ROW (the header holding the name + the chosen value) so the ⓘ
      // lands to the RIGHT of the chosen value — not between the label and the value.
      var row = nameEl;
      if (row !== group) {
        while (row.parentNode && row.parentNode !== voBlock && !row.parentNode.contains(group)) { row = row.parentNode; }
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dq-info-trigger';
      btn.setAttribute('aria-label', 'About diamond quality');
      btn.innerHTML = infoSvg();
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var trigger = drawerTrigger();
        if (!trigger) { return; }
        var q = selectedQuality(group);
        if (q) { trigger.setAttribute('data-selected-quality', q); }
        trigger.click();
      });
      row.appendChild(btn);
    } catch (e) { /* fail silently */ }
  }

  // Re-run injection on any DOM change (debounced). VO renders/rebuilds its block asynchronously and
  // on every option change — and may replace the container entirely — so we watch the whole document
  // rather than a single (possibly stale) node. inject() is cheap and self-guarding, so this is light.
  var dqScheduled = false;
  function dqRun() {
    dqScheduled = false;
    inject(document.querySelector(VO_SELECTOR));
  }
  function dqSchedule() {
    if (dqScheduled) { return; }
    dqScheduled = true;
    // setTimeout (not requestAnimationFrame): rAF is paused on backgrounded/non-painting tabs,
    // which would defer re-injection indefinitely; a timer fires regardless of paint state.
    setTimeout(dqRun, 16);
  }
  function start() {
    dqRun();
    try {
      new MutationObserver(dqSchedule).observe(document.body || document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Fix: BCPO replaces the add-to-cart button after Broadcast's product-form
   caches it; refresh the stale reference before the theme's submit handler runs. */
document.addEventListener('submit', function (e) {
  var pf = e.target && e.target.closest ? e.target.closest('product-form') : null;
  if (!pf || !pf.submitButton || pf.submitButton.isConnected) return;
  var live = pf.querySelector('[type="submit"]');
  if (!live) return;
  pf.submitButton = live;
  pf.submitButtonText = live.querySelector('[data-add-to-cart-text]') || pf.submitButtonText;
}, true);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
